import React from 'react';

// State
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentView,
  selectCurrentView
} from 'src/react/recommendations/store/slices/view';
import { selectUncompletedTasks } from 'src/react/recommendations/store/slices/tasks';

// Components
import RecommendationIdeas from 'src/react/recommendations/IdeaList';
import TaskList from 'src/react/recommendations/TaskList';
import ToggleButton from 'src/react/recommendations/components/ToggleButton/ToggleButton';
import RecommendationModalView from './RecommendationModalView';

// eslint-disable-next-line prefer-reflect
const has = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

export const EXPLORE_ROUTE = 'explore';
export const MY_LIST_ROUTE = 'my_list';

const views = {
  [MY_LIST_ROUTE]: TaskList,
  [EXPLORE_ROUTE]: RecommendationIdeas
};

const RecommendationLayout = () => {
  const dispatch = useDispatch();
  const uncompletedTasks = useSelector(selectUncompletedTasks);
  const enabledView = useSelector(selectCurrentView);

  const isEnabledView = (item) => item === enabledView;
  const getEnabledView = (name) => {
    if (!has(views, name)) {
      return views.my_list;
    }

    return views[name];
  };

  const EnabledViewComponent = getEnabledView(enabledView);
  const navigateTo = (name) => () => {
    dispatch(setCurrentView(name));
  };

  return (
    <>
      <div className="p-2 sm:p-6 bg-white rounded-md shadow-md Recommendations flex flex-col items-center">
        <div className="Recommendations-Toggle mb-3 sm:mb-4 w-full">
          <div className="Recommendations-ToggleButtons bg-gray-20">
            <ToggleButton
              isActive={isEnabledView(MY_LIST_ROUTE)}
              className="Recommendations-ToggleButton"
              onClick={navigateTo(MY_LIST_ROUTE)}
              data-testid="navigation_toggle_my_list"
            >
              <span>My List</span>
              <span
                data-testid="toggle_count_label"
                className="ml-1 Recommendations-ListAddedCount text-1"
              >
                {uncompletedTasks?.length}
              </span>
            </ToggleButton>
            <ToggleButton
              isActive={isEnabledView(EXPLORE_ROUTE)}
              className="Recommendations-ToggleButton"
              onClick={navigateTo(EXPLORE_ROUTE)}
              data-testid="navigation_toggle_explore"
            >
              Explore
            </ToggleButton>
          </div>
        </div>
        <div className="Recommendations-Content w-full">
          <EnabledViewComponent />
        </div>
        <RecommendationModalView />
      </div>
    </>
  );
};

export default RecommendationLayout;
